export default {
  getCoreAccount() {
    const obj = {
      actionType: appConstants.ActionTypes.CORE_SHOW_USER,
      data: { client: 'employee_web' },
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  checkTokenValidity(callback) {
    const obj = {
      callback,
      actionType: appConstants.ActionTypes.CHECK_TOKEN_EXPIRATION,
    };
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  // account data changed
  changedData(user) {
    const obj = {
      actionType: appConstants.ActionTypes.USER_CHANGED,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('USER_PARAM')] = user;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  updateUser(user) {
    const obj = {
      actionType: appConstants.ActionTypes.UPDATE_USER,
      postData: {},
    };
    obj.postData[Utils.getEndpointParam('USER_PARAM')] = user;
    MakeShiftEmployeeDispatcher.dispatch(obj);
  },

  updatePassword(user_id, current_password, new_password) {
    MakeShiftEmployeeDispatcher.dispatch({
      actionType: appConstants.ActionTypes.UPDATE_PASSWORD,
      postData: {
        current_password,
        password: new_password,
        password_confirmation: new_password,
      },
    });
  },
};
